document.addEventListener('DOMContentLoaded', function () {

  const params = new URLSearchParams(window.location.search);
  const email = params.get('email');

  if (!email) return;

  const fillForms = setInterval(function () {

    /* FORM STANDARD */
    const normalFields = document.querySelectorAll(
      'input[type="email"], input[name="email"], input[name="$email"]'
    );

    normalFields.forEach(function(field) {

      if (field.dataset.filled) return;

      field.value = email;

      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));

      field.dataset.filled = 'true';
    });


    /* POPUP KLAVIYO */
    const klaviyoForm = document.querySelector(
      'form[data-testid="klaviyo-form-Ut56V7"]'
    );

    if (klaviyoForm) {

      const popupEmail = klaviyoForm.querySelector(
        'input[type="email"]'
      );

      if (popupEmail && !popupEmail.dataset.filled) {

        popupEmail.value = email;

        popupEmail.dispatchEvent(
          new Event('input', { bubbles: true })
        );

        popupEmail.dispatchEvent(
          new Event('change', { bubbles: true })
        );

        popupEmail.dataset.filled = 'true';
      }
    }

  }, 300);

  setTimeout(function () {
    clearInterval(fillForms);
  }, 10000);

});


(function () {
  if (document.getElementById('mood-klaviyo-css')) return;

  const style = document.createElement('style');
  style.id = 'mood-klaviyo-css';
  style.textContent = `
    .needsclick.kl-private-reset-css-Xuajs1 { width: 100% !important;}

    form.klaviyo-form [data-testid="form-component"] {display: inherit!important;}

    .kl-private-reset-css-Xuajs1 {font-family: var(--font-body-family) !important;}

    .klaviyo-form,
    .klaviyo-form *,
    [class*="kl-private-reset-css"],
    [class*="kl-private-reset-css"] * {font-family: var(--font-body-family) !important;}
  `;
  document.head.appendChild(style);
})();